<mojo-about [display]="true" (displayChange)="onDisplayChange($event)"></mojo-about>
